<template>
    <list-group-item :action="clickAction" color="primary">
        <strong>Booking #{{ this.booking.id }} Guest Details Required</strong>
        <div class="my-2">
            {{ booking.checkInDateTime.format('n/j/Y') }} - {{ booking.checkOutDateTime.format('n/j/Y') }}
        </div>
        <ui-button size="sm" :block="true">
            Confirm Booking
        </ui-button>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            ...UIComponents,
        },

        props: {
            booking: {
                type: ApiObject,
                required: true,
            },
        },

        emits: ['click'],

        methods: {
            clickAction() {
                this.$emit('click');
                this.$router.push('/travelers/bookings/'+this.booking.id+'/confirm');
            },
        },
    }
</script>